import React from 'react';
import { CheckCircle } from 'lucide-react';

const AdvantagesSection: React.FC = () => {
  const advantages = [
    {
      title: "Modular",
      description: "In 7 übersichtlichen Modulen lernen Sie alle relevanten Aspekte des EU AI Acts"
    },
    {
      title: "Mobil",
      description: "Lernen Sie flexibel auf allen Geräten - PC, Tablet oder Smartphone"
    },
    {
      title: "Günstig",
      description: "Kosteneffiziente Lösung speziell für KMU und Startups konzipiert"
    },
    {
      title: "Schnell",
      description: "In nur 30 Minuten erreichen Sie die notwendige Compliance"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Ihre Vorteile auf einen Blick</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Unser KI-Kompetenznachweis bietet Ihnen zahlreiche Vorteile gegenüber herkömmlichen Schulungen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {advantages.map((advantage, index) => (
            <div 
              key={index} 
              className="bg-gray-50 rounded-lg p-8 transition-all duration-300 hover:shadow-md hover:-translate-y-1"
            >
              <div className="flex items-start">
                <CheckCircle className="text-[#2574B5] mr-4 flex-shrink-0 mt-1" size={24} />
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">
                    {advantage.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {advantage.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;